import { Input } from "reactstrap";

export default function FilterSelect({ label, options, value, onChange }) {
  return (
    <label className="d-flex flex-column mb-0">
      <span className="small text-uppercase fw-bold mb-1">{label}</span>
      <Input
        type="select"
        bsSize="sm"
        className="w-auto"
        value={value}
        onChange={(event) => onChange(event.target.value)}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Input>
    </label>
  );
}
